import React from "react";
import FormWrapper from "../../ServeToThrive/shared/FormWrapper";

export default function OnboardingComplete({ formData, userRole, onGoToExplore, onViewProfile, userId }) {
  const isServing = userRole === "serve" || userRole === "both";
  const isInviting = userRole === "invite" || userRole === "both";

  return (
    <FormWrapper>
      <div style={{ textAlign: "center", animation: "scaleIn 0.5s ease" }}>
        {/* Success icon */}
        <div style={{ width: "72px", height: "72px", backgroundColor: "#f3f4f6", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 24px", border: "2px solid #36454F" }}>
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#36454F" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>

        <h1 style={{ fontSize: "28px", fontWeight: "700", color: "#1a1a1a", marginBottom: "12px", letterSpacing: "-0.5px" }}>
          You're all set{formData.name ? `, ${formData.name.split(" ")[0]}` : ""}!
        </h1>

        {isServing && (
          <div style={{ padding: "16px", backgroundColor: "#f3f4f6", borderRadius: "10px", marginBottom: "16px", border: "1px solid #e5e7eb", textAlign: "left" }}>
            <div style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#36454F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0, marginTop: "1px" }}>
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.99 15a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.92 4h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 11.91" />
              </svg>
              <div>
                <p style={{ fontSize: "14px", fontWeight: "600", color: "#36454F", margin: "0 0 4px" }}>Reference email sent</p>
                <p style={{ fontSize: "13px", color: "#6b7280", margin: 0, lineHeight: "1.5" }}>
                  We've emailed <strong>{formData.refereeName}</strong> to verify your profile. Your profile will become visible on Collavo once they confirm.
                </p>
              </div>
            </div>
          </div>
        )}

        {isInviting && !isServing && (
          <p style={{ fontSize: "15px", color: "#737373", marginBottom: "24px", lineHeight: "1.6" }}>
            Your account is ready. You can now browse gifted people ready to serve your church or event.
          </p>
        )}

        {isServing && (
          <p style={{ fontSize: "14px", color: "#737373", marginBottom: "32px", lineHeight: "1.6" }}>
            While you wait, you can browse others on Collavo or view your profile.
          </p>
        )}

        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          <button onClick={onGoToExplore}
            style={{ width: "100%", padding: "16px 24px", fontSize: "16px", fontWeight: "600", color: "#fff", backgroundColor: "#36454F", border: "none", borderRadius: "8px", cursor: "pointer", transition: "all 0.2s ease", display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}
            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#2d3a42"; e.currentTarget.style.transform = "translateY(-1px)"; }}
            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "#36454F"; e.currentTarget.style.transform = "translateY(0)"; }}>
            {isInviting ? "Browse gifted people" : "Explore Collavo"}
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" /></svg>
          </button>

          {isServing && userId && (
            <button onClick={onViewProfile}
              style={{ width: "100%", padding: "14px 24px", fontSize: "15px", fontWeight: "500", color: "#1a1a1a", backgroundColor: "#fff", border: "1px solid #e5e5e5", borderRadius: "8px", cursor: "pointer", transition: "all 0.2s ease" }}
              onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#1a1a1a"; }}
              onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#e5e5e5"; }}>
              View my profile
            </button>
          )}
        </div>
      </div>
    </FormWrapper>
  );
}
